import { connect } from "@formily/react";
import { Input } from "./Input";

export const Email = connect((props) => {
  const enhancedProps = {
    ...props,
    inputMode: "email",
  };

  return <Input {...enhancedProps} />;
});
